<script setup>
defineProps({
  title: {
    type: String,
  },
  links: {
    type: Array,
  },
})
</script>

<template>
  <div class="border-med-aqua pl-0 pt-6 border-t-2 xl:border-t-0 xl:border-l-2 xl:p-0 xl:pl-6 mb-[60px] block-spacing w-full container-text eight-col-max ml-auto mr-auto">
    <h2
      v-if="title"
      class="h2 text-slate-800 text-xl font-medium mb-6"
    >
      {{ title }}
    </h2>

    <ul class="space-y-6">
      <li
        v-for="(link, index) in links"
        :key="index"
      >
        <ULink
          :to="useCmsUrl(link.url)"
          :locale="false"
          class="hover:underline text-med-dark-gray"
        >
          {{ link.text }}
        </ULink>
      </li>
    </ul>
  </div>
</template>
